import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pass-key-terms-and-conditions',
  templateUrl: './pass-key-terms-and-conditions.component.html',
  styleUrl: './pass-key-terms-and-conditions.component.scss',
  standalone: false
})
export class PassKeyTermsAndConditionsComponent implements OnInit {

  onAcceptTermsAndConditionsSubmit: () => void;
  onDeclineTermsAndConditionsSubmit: () => void;

  constructor(){ }

  ngOnInit(): void {
  }

  onAcceptTermsAndConditionsClick(){
    this.onAcceptTermsAndConditionsSubmit();
  }

  onDeclineTermsAndConditionsClick(){
     this.onDeclineTermsAndConditionsSubmit();
  }
}
